export let brands = [
  {
    "id": 3,
    "name": "DEMETRIOS"
  },
  {
    "id": 621,
    "name": "ANTONIO RIVA MILANO"
  },
  {
    "id": 417,
    "name": "B by Yolancris"
  },
  {
    "id": 536,
    "name": "JESUS PEIRO"
  },
  {
    "id": 632,
    "name": "GIADA CURTI RESORT"
  },
  {
    "id": 534,
    "name": "GALI KARTEN Bridal Couture"
  },
  {
    "id": 116,
    "name": "Les Couronnes de Victoire"
  },
  {
    "id": 81,
    "name": "POESIE SPOSA"
  },
  {
    "id": 66,
    "name": "Cymbeline"
  },
  {
    "id": 510,
    "name": "Ilette Collection"
  },
  {
    "id": 603,
    "name": "SEDOMIR RODRIGUEZ DE LA SIERRA "
  },
  {
    "id": 127,
    "name": "Christian Koehlert Paris"
  },
  {
    "id": 465,
    "name": "Petrelli Uomo"
  },
  {
    "id": 625,
    "name": "Italiana accessori"
  },
  {
    "id": 641,
    "name": "INUÑEZ STUDIO"
  },
  {
    "id": 626,
    "name": "GUILLERMO VILLANUEVA"
  },
  {
    "id": 622,
    "name": "Jenny Packham"
  },
  {
    "id": 600,
    "name": "ISABEL SANCHIS"
  },
  {
    "id": 135,
    "name": "Yolancris"
  },
  {
    "id": 136,
    "name": "EVA JANSSENS"
  },
  {
    "id": 500,
    "name": "TALBOT RUNHOF"
  },
  {
    "id": 619,
    "name": "Olimpia Sanchis"
  },
  {
    "id": 539,
    "name": "Victor Harper"
  },
  {
    "id": 128,
    "name": "Maylori"
  },
  {
    "id": 129,
    "name": "FEDE"
  },
  {
    "id": 467,
    "name": "Papilio"
  },
  {
    "id": 480,
    "name": "Marco & María"
  },
  {
    "id": 131,
    "name": "HIGARNOVIAS"
  },
  {
    "id": 138,
    "name": "Diamentia"
  },
  {
    "id": 181,
    "name": "Serena Whitehaven"
  },
  {
    "id": 182,
    "name": "Ainhoa Salcedo Couture"
  },
  {
    "id": 605,
    "name": "ROBERTO CAVALLI"
  },
  {
    "id": 496,
    "name": "LÉONIE"
  },
  {
    "id": 642,
    "name": "ELISABETTA POLIGNANO"
  },
  {
    "id": 470,
    "name": "Mysecret Sposa"
  },
  {
    "id": 183,
    "name": "TOCADOS CLOCHE"
  },
  {
    "id": 476,
    "name": "WHITE ONE"
  },
  {
    "id": 477,
    "name": "LADYBIRD"
  },
  {
    "id": 472,
    "name": "Angelo Toma"
  },
  {
    "id": 474,
    "name": "NICOLE"
  },
  {
    "id": 202,
    "name": "Lorena Panea"
  },
  {
    "id": 475,
    "name": "HOUSE OF ST.PATRICK"
  },
  {
    "id": 473,
    "name": "PRONOVIAS"
  },
  {
    "id": 484,
    "name": "Carta Branca "
  },
  {
    "id": 481,
    "name": "LAUWOOD HANDBAGS"
  },
  {
    "id": 483,
    "name": "FELY CAMPO"
  },
  {
    "id": 486,
    "name": "MARYLISE"
  },
  {
    "id": 607,
    "name": "Maria Pia"
  },
  {
    "id": 482,
    "name": "Vela"
  },
  {
    "id": 488,
    "name": "Serrese"
  },
  {
    "id": 485,
    "name": "Rembo Styling"
  },
  {
    "id": 130,
    "name": "FLORA"
  },
  {
    "id": 137,
    "name": "Sophie et Voilà"
  },
  {
    "id": 590,
    "name": "RITA MODE MADE IN ITALY"
  },
  {
    "id": 501,
    "name": "ERSA ATELIER"
  },
  {
    "id": 499,
    "name": "RAMON SANJURJO"
  },
  {
    "id": 489,
    "name": "Madi Lane Bridal"
  },
  {
    "id": 511,
    "name": "Jessie Q"
  },
  {
    "id": 502,
    "name": "Watters"
  },
  {
    "id": 479,
    "name": "Yumi Katsura"
  },
  {
    "id": 478,
    "name": "ERNESTO TERRÓN"
  },
  {
    "id": 543,
    "name": "Ashley & Justin"
  },
  {
    "id": 604,
    "name": "Diane Legrand"
  },
  {
    "id": 503,
    "name": "NICOLÁS MONTENEGRO"
  },
  {
    "id": 90,
    "name": "ISABELLE FAJARDO"
  },
  {
    "id": 125,
    "name": "The Atelier"
  },
  {
    "id": 91,
    "name": "VESTAL HAUTE COUTURE"
  },
  {
    "id": 2,
    "name": "ASLI DOĞAN"
  },
  {
    "id": 535,
    "name": "ATELIER EMELIA PARIS"
  },
  {
    "id": 598,
    "name": "VALENTINI"
  },
  {
    "id": 601,
    "name": "Amelia Casablanca"
  },
  {
    "id": 645,
    "name": "MAISON SIGNORE"
  },
  {
    "id": 532,
    "name": "Pol Núñez"
  },
  {
    "id": 466,
    "name": "OLGA MACIA"
  },
  {
    "id": 608,
    "name": "Cristiano Lucci"
  },
  {
    "id": 487,
    "name": "MARÍA BARRAGAN"
  },
  {
    "id": 416,
    "name": "SOPHIE"
  },
  {
    "id": 646,
    "name": "BLUMARINE"
  },
  {
    "id": 471,
    "name": "Calzoleria Marini dal 1945"
  },
  {
    "id": 544,
    "name": "Evie Young"
  },
  {
    "id": 225,
    "name": "ANNIE EL TALLER DE SEDA"
  },
  {
    "id": 591,
    "name": "Bellantuono"
  }
] 
